import { render, staticRenderFns } from "./ViewLogin.vue?vue&type=template&id=0a2d080a&scoped=true&"
import script from "./ViewLogin.vue?vue&type=script&lang=ts&"
export * from "./ViewLogin.vue?vue&type=script&lang=ts&"
import style0 from "./ViewLogin.vue?vue&type=style&index=0&id=0a2d080a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2d080a",
  null
  
)

export default component.exports